import { ORDER_ASC } from "../../../api/helpers/pagination";

export const DEFAULT_PAGINATION_CONFIGURATION = {
  id: {
    defaultValue: undefined,
  },
  limit: {
    defaultValue: 25,
    parser: Number,
  },
  order: {
    defaultValue: ORDER_ASC,
  },
  orderBy: {
    defaultValue: "nickname",
  },
  page: {
    defaultValue: 1,
    parser: Number,
  },
  search: {
    defaultValue: "",
  },
} as const;
